 import './about.css';
const subTitle = "About Us";
const title = "Where Art, Creativity & Talent Come Alive";
const desc = "Kalakakshaaha is a creative space dedicated to nurturing artistic talent through expert training, inspiring mentors, and a vibrant learning environment We help learners explore their passion for performing arts, fine arts, music, dance, acting, and creative expression.With a perfect blend of qualified instructors, structured programs, and modern teaching method.";
 
 const vibgyorColors = [
//   "#8B00FF", // Violet
//   "#4B0082", // Indigo
//   "#0000FF", // Blue
//   "#00FF00", // Green
  "#FFFF00", // Yellow
  "#FF7F00", // Orange
  "#FF0000", // Red
];


 
const aboutList = [
    {
        imgUrl: 'assets/images/about/icon/01.jpg',
        imgAlt: 'about icon rajibraj91 rajibraj',
        title: 'Skilled Instructors',
        desc: 'Learn from experienced artists and certified professionals who bring real-world knowledge, stage experience, and teaching excellence.',
    },
    {
        imgUrl: 'assets/images/about/icon/02.jpg',
        imgAlt: 'about icon rajibraj91 rajibraj',
        title: 'Art Categories',
        desc: 'From rhythm to realism, explore the many ways to create and express',
    },
    {
        imgUrl: 'assets/images/about/icon/03.jpg',
        imgAlt: 'about icon rajibraj91 rajibraj',
        title: 'Online Classes',
        desc: 'Whether you prefer flexible online learning or hands-on studio sessions, Kalakakshaaha offers both. Enjoy high-quality teaching from anywhere, at your own pace.',
    },
]
 


 
const About = () => {
    return (
        <div className="about-section" >
            <div className="container">
                <div className="row justify-content-center row-cols-xl-2 row-cols-1 align-items-end flex-row-reverse">
                    <div className="col">
                        <div className="about-right padding-tb">
                            <div className="section-header">
                                <span style={{ fontSize: "25px", fontWeight: "bold", color: "skyblue"}}>{subTitle}</span>
 
                                <h2 className="title"style={{ color: "white" }}>{title}</h2>
                                <p style={{ color: "white" }}>{desc}</p>
                            </div>
                            <div className="section-wrapper">
                                <ul className="lab-ul" style={{ color: "white" }}>
                                    {aboutList.map((val, i) => (
                                        <li key={i}>
                                            <div className="sr-left"style={{
          width: "70px",
          height: "70px",
          borderRadius: "12px",
          background: vibgyorColors[i % vibgyorColors.length],  // 🌈
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
        }}>
                                                <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                            </div>
                                            <div className="sr-right">
                                                <h5 style={{ color: "white" }}>{val.title}</h5>
                                                <p style={{ color: "white" }}>{val.desc}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="about-left">
                            <div className="about-thumb">
                                <img src="assets/images/about/01.png" alt="about" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default About;